import React, { Component } from 'react'
import { Table, Button, Icon, Input, Modal, Select, Col, Row } from 'antd';
import {connect} from "react-redux";
import PropTypes from 'prop-types';
import moment from 'moment';
import * as APP_CONFIG from "../constants/config";
//import MalfunctionsRow from "./MalfunctionsRow";
//import ReactTable from "react-table";
import "react-table/react-table.css";
import {malfunctionsFetchList, addMalfunction} from '../actions/malfunctions';
const Option = Select.Option;
const {DateFormat, benchmarkApi} = APP_CONFIG;
const storingtypen = APP_CONFIG.defaults.storingtypen;

class ListMalfunctions extends Component {

    static propTypes = {
        malfunctions: PropTypes.array.isRequired,
    };

    constructor(props) {
        super(props);
        this.state = {
            modalVisible: false,
            expanded: {},
            malfunctions: [],
            customers: {},
            locations: [],
            selectedCustomer: '',
            selectedLocation: '',
            selectedLocationId: 0,
            //tableFilter: '',
            searchText: '',
        };
    }

    componentWillMount = async () => {
        await this.props.dispatch(malfunctionsFetchList());
        this.setState({malfunctions: this.props.malfunctions});
        const customers = await this.getCustomers();
        const selCustomer = Object.keys(customers).sort()[0];
        this.setState({
            malfunctions: this.props.malfunctions,
            customers: customers,
            selectedCustomer: selCustomer});
        this.handleChange(selCustomer);
    }


        columns = [
            {
                title: "Klant",
                dataIndex: "klant",
                accessor: "klant",
                key: "klant",
                filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                    <div className="custom-filter-dropdown">
                        <Input
                            ref={ele => this.searchInput = ele}
                            placeholder="Zoek klant.."
                            value={selectedKeys[0]}
                            onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                            onPressEnter={this.handleSearch(selectedKeys, confirm)}
                        />
                        <Button type="primary" onClick={this.handleSearch(selectedKeys, confirm)}>Zoek</Button>
                        <Button onClick={this.handleReset(clearFilters)}>Reset</Button>
                    </div>
                ),
                filterIcon: filtered => <Icon type="filter" style={{ color: filtered ? '#108ee9' : '#aaa' }} />,
                onFilter: (value, record) => record.klant.toLowerCase().includes(value.toLowerCase()),
                onFilterDropdownVisibleChange: (visible) => {
                    if (visible) {
                        setTimeout(() => {
                            this.searchInput.focus();
                        });
                    }
                }
            },
            {
                title: "Locatie",
                dataIndex: "locatie",
                filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                    <div className="custom-filter-dropdown">
                        <Input
                            ref={ele => this.searchInput = ele}
                            placeholder="Zoek Locatie.."
                            value={selectedKeys[0]}
                            onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                            onPressEnter={this.handleSearch(selectedKeys, confirm)}
                        />
                        <Button type="primary" onClick={this.handleSearch(selectedKeys, confirm)}>Zoek</Button>
                        <Button onClick={this.handleReset(clearFilters)}>Reset</Button>
                    </div>
                ),
                filterIcon: filtered => <Icon type="filter" style={{ color: filtered ? '#108ee9' : '#aaa' }} />,
                onFilter: (value, record) => record.locatie.toLowerCase().includes(value.toLowerCase()),
                onFilterDropdownVisibleChange: (visible) => {
                    if (visible) {
                        setTimeout(() => {
                            this.searchInput.focus();
                        });
                    }
                },
            },
            {
                title: "Type storing",
                dataIndex: "storingtype",
                accessor: "storingtype",
                filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                    <div className="custom-filter-dropdown">
                        <Select onChange={value => {
                            setSelectedKeys(value ? [value] : []);
                        }} onSelect={() => this.handleSearch(selectedKeys, confirm)} style={{width: "150px", display: "block"}}>
                            {
                                storingtypen.map((stype,index) => {
                                    if(index === selectedKeys[0])
                                        return(
                                            <Select.Option key={stype.type} value={stype.type} selected>{stype.type}</Select.Option>
                                        );
                                    else
                                        return(
                                            <Select.Option key={stype.type} value={stype.type}>{stype.type}</Select.Option>
                                        );
                                })
                            }
                        </Select>
                        <Button type="primary" onClick={this.handleSearch(selectedKeys, confirm)}>Filter</Button>
                        <Button onClick={this.handleReset(clearFilters)}>Reset</Button>
                    </div>
                ),
                filterIcon: filtered => <Icon type="filter" style={{ color: filtered ? '#108ee9' : '#aaa' }} />,
                onFilter: (value, record) => record.storingtype.toLowerCase().includes(value.toLowerCase()),
                onFilterDropdownVisibleChange: (visible) => {
                    if (visible) {
                        setTimeout(() => {
                            this.searchInput.focus();
                        });
                    }
                },
            },
            {
                title: "Datum Aanmelding",
                dataIndex: "aanmeldingsdatum",
                defaultSortOrder: 'ascend',
                sorter: (a, b) => {
                    let diff = moment(b, DateFormat).diff(moment(a, DateFormat));
                    return diff < 0 ? -1 : diff > 0 ? 1 : 0;
                },
                render:  (text,record) => (
                    moment(record.aanmeldingsdatum).format(DateFormat)
                ),
                id: "aanmeldingsdatum",
                filterable: false,
            },
            {
                title: "Opgelost",
                dataIndex: "opgelost",
                filterable: false,
                render: (text, record) => {

                    const solved = this.isSolved(record.actions);
                    return (<div
                        style={{
                            width: '100%',
                            height: '100%',
                            textAlign:"center",
                            verticalAlign:"middle"
                        }}
                    ><input type="checkbox" checked={solved} readOnly />
                    </div>);
                },
                Cell: row => {
                    const solved = this.isSolved(row.original.actions);
                    return (<div
                        style={{
                            width: '100%',
                            height: '100%',
                            textAlign:"center",
                            verticalAlign:"middle"
                        }}
                    ><input type="checkbox" checked={solved} readOnly />
                    </div>);
                },
            },
            {
                title: "",
                render: (text, record) => {
                    return <Button type="primary" onClick={()=>this.toEdit(record.id)}>Aanpassen</Button>
                }
            }
        ];



    toEdit = (id) => {
        //console.log(`toEdit: ${id}`);
        this.props.history.push(`/storingen/${id}`);

    }

    resetModal = () => {
        const selCustomer = Object.keys(this.state.customers).sort()[0];
        this.setState({
            modalVisible: false,
            locations: this.state.customers[selCustomer],
            selectedCustomer: selCustomer,
            selectedLocation: this.state.customers[selCustomer][0].locatie,
            selectedLocationId: this.state.customers[selCustomer][0].locatie_id
        });
    }

    addMalfunction = async (klant, locatie, locatie_id) => {
        try {
            const malfunction = {
                ...APP_CONFIG.defaults.malfunction,
                klant: klant,
                locatie: locatie,
                locatie_id: locatie_id
            };
            const insertedMalfunction = await this.props.dispatch(addMalfunction(malfunction));
            const newMalfunctionId = insertedMalfunction.result.newlyInsertedId;

            //console.log(`newMalfunctionId: ${newMalfunctionId}`);
            await this.props.dispatch(malfunctionsFetchList());
            this.setState({malfunctions: this.props.malfunctions});
            this.props.history.push(`/storingen/${newMalfunctionId}/edit`);
        }
        catch(err){
            console.error(`Error post storing: ${err}`);
        }
    };

    getCustomers = async () => {
        const request = await fetch(`${benchmarkApi}locations`);
        let items = await request.json();
        let customers = {};
        if(items && items.length)
            items.map(item => {
                if (item.org_name) {
                    if (!customers.hasOwnProperty(item.org_name)) {
                        customers[item.org_name] = [];
                    }
                    customers[item.org_name].push({
                        locatie: item.name,
                        locatie_id: parseInt(item.id, 10),
                        city_name: item.city_name
                    });
                }
                else {
                    customers[item.name] = [{
                        locatie: item.city_name,
                        locatie_id: parseInt(item.id, 10),
                        city_name: item.city_name
                    }];
                }
                return null;
            });

        return customers;
    };

    handleRowExpanded(newExpanded, index, event) {
        let uitgevouwen = newExpanded[Object.keys(newExpanded)[0]];
        this.setState({
            // we override newExpanded, keeping only current selected row expanded
            expanded: {[index]: uitgevouwen}
        });
    }

    resetExpanded(){
        this.setState({
            expanded: {}
        });
    }

    isSolved(actions){
        let solved = false;
        if(actions && actions.length)(
            actions.forEach((action) => {
                if (action.opgelost) {
                    solved = true;
                    return;
                }
            })
        )
        return solved;
    }

    handleChange = (klant) => {

        if(this.state.customers){
            this.setState({
                selectedCustomer: klant,
                locations: this.state.customers[klant].sort((a,b) => {
                    if(a.locatie < b.locatie) return -1;
                    if(a.locatie > b.locatie) return 1;
                    return 0;
                }),
                selectedLocation: this.state.customers[klant][0].locatie,
                selectedLocationId: this.state.customers[klant][0].locatie_id
            });
        }else{
            console.log('this.state.customers.length', this.state.customers.length)
        }
    }

    handleChangeLocation = (locationId) => {
        let locatieItem = this.state.customers[this.state.selectedCustomer].find(item => {
            return item.locatie_id === parseInt(locationId,10);
        });

        this.setState({
            selectedLocation: locatieItem.locatie,
            selectedLocationId: locationId
        });
    }

    renderSelectLocatie = () => {
        return (
            <div>
                <Row gutter={{xs: 0, md: 24}} className="dataview-row">
                    <Col xs={24} md={5} className="dataview-label">
                        <label htmlFor="selLocations" style={{marginRight: '10px', fontWeight:'bold'}}>Locatie</label>
                    </Col>
                    <Col xs={24} md={10} className="dataview-label">
                        <Select
                            id="selLocations"
                            style={{ width: 300}}
                            defaultActiveFirstOption={false}
                            value={this.state.selectedLocation}
                            onChange={this.handleChangeLocation}>
                            {
                                this.state.locations.map(item => {
                                    return(
                                        <Option key={item.locatie_id} value={item.locatie_id}>{item.locatie}</Option>
                                    );
                                })
                            }
                        </Select>
                    </Col>
                </Row>
            </div>
        );
    }

    renderSelectKlant = () => {
        return (
            <div>
                <Row gutter={{xs: 0, md: 24}} className="dataview-row">
                    <Col xs={24} md={5} className="dataview-label">
                        <label htmlFor="selCustomer" style={{marginRight: '10px', fontWeight:'bold'}}>Klant</label>
                    </Col>
                    <Col xs={24} md={10} className="dataview-label">
                        <Select
                            id="selCustomer"
                            autoFocus
                            showSearch
                            style={{ width: 300 }}
                            optionFilterProp="children"
                            onChange={this.handleChange}
                            value={this.state.selectedCustomer}
                            filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                        >
                            {
                                Object.keys(this.state.customers).sort().map((klant,ndx) => {
                                    return(
                                        <Option key={ndx} value={klant}>{klant}</Option>
                                    );
                                })
                            }
                        </Select>
                    </Col>
                </Row>
            </div>)
    }

    selectCustomer = () => {
        const klant = this.state.selectedCustomer;
        const locatie = this.state.selectedLocation;
        const locatie_id = parseInt(this.state.selectedLocationId,10);

        if(klant.length && locatie.length && locatie_id > 0){
            this.addMalfunction(klant,locatie,locatie_id);
            this.resetModal();
        }
    }

    showModal = () => {
        this.setState({modalVisible: true});
    }

    handleCancel = () => {
        //console.log(`handleCancel`);
        this.resetModal();
    }

    afterClose = () =>{
        this.resetModal();
    }

    handleSearch = (selectedKeys, confirm) => () => {
        confirm();
        this.setState({ searchText: selectedKeys[0] });
    }

    handleReset = clearFilters => () => {
        clearFilters();
        this.setState({ searchText: '' });
    }

    render() {
        const { malfunctions } = this.state;
        return <div>

            {/*<ReactTable
                data={malfunctions}
                filterable
                expanded={this.state.expanded}
                onExpandedChange={(newExpanded, index, event) => this.handleRowExpanded(newExpanded, index, event)}
                onPageChange={(pageIndex) => {this.resetExpanded()}}

                columns={[
                    {
                        Header: "Klant",
                        accessor: "klant",
                        filterMethod: (filter, row) =>
                            row[filter.id].toUpperCase().indexOf(filter.value.toUpperCase()) === 0
                    },
                    {
                        Header: "Type storing",
                        accessor: "storingtype",
                        filterable: false,
                    },
                    {
                        Header: "Datum Aanmelding",
                        id: "aanmeldingsdatum",
                        accessor: d => {
                            return moment(d.aanmeldingsdatum).format(DateTimeFormat)
                        },
                        sortMethod: (a, b) => {
                            let diff = moment(b, DateTimeFormat).diff(moment(a, DateTimeFormat));
                            return diff < 0 ? -1 : diff > 0 ? 1 : 0;
                        },
                        filterable: false,
                    },
                    {
                        Header: "Opgelost",
                        filterable: false,
                        Cell: row => {
                            const solved = this.isSolved(row.original.actions);
                            return (<div
                                style={{
                                    width: '100%',
                                    height: '100%',
                                    textAlign:"center",
                                    verticalAlign:"middle"
                                }}
                            ><input type="checkbox" checked={solved} readOnly />
                            </div>);
                        },
                    },
                ]}
                defaultSorted={[
                    {
                        id: "aanmeldingsdatum",
                        asc: true
                    }
                ]}
                defaultPageSize={10}
                className="-striped -highlight"
                SubComponent={row => {
                    return (
                        <div style={{ paddingLeft: "0%" }}>
                            <MalfunctionsRow malfunction={row.original} solved={this.isSolved(row.original.actions)}/>
                        </div>
                    );
                }}
            />*/}

            {/*<div>
                Filter: <input type="text" value={tableFilter} onChange={(event) => this.setState({tableFilter: event.target.val})} />
            </div>*/}
             <Table
                className="project-table"
                columns={this.columns}
                dataSource={malfunctions}
                pagination={true}
                bordered={false}
                rowKey={'id'}
                style={{marginBottom: '30px'}}
            />

            <Modal
                title="Kies klant en locatie"
                visible={this.state.modalVisible}
                onCancel={() => this.setState({ modalVisible : false})}
                afterClose={() => this.afterClose()}
                footer={[
                    <Button key="cancel" type="primary" onClick={() => this.handleCancel()}>Cancel</Button>,
                    <Button key="submit" type="primary" onClick={() => this.selectCustomer()}>
                        Toevoegen
                    </Button>
                ]}
            >
                {this.renderSelectKlant()}
                <br/>
                {this.renderSelectLocatie()}

            </Modal>
            <Button type="primary" onClick={() => this.showModal()}>Toevoegen</Button>
        </div>;
    }
}

let mapStateToProps = ({malfunctions}) => {
    return {
        malfunctions: [...malfunctions.malfunctions]
    }
};

export default connect(mapStateToProps)(ListMalfunctions);

/*
*
*
* */




// WEBPACK FOOTER //
// ./src/components/ListMalfunctions.js